import classNames from 'classnames';

import LinkIcon from '../icons/Link';
import Button from './Button';

import styles from '../../../styles/buttons/sharecopy.module.css';

interface ShareCopyButtonProps {
    direction?: 'left' | 'right';
    color?: string | null;
    className?: string | null;
}

function ShareCopyButton({
    direction = 'left',
    color = null,
    className = null,
    ...props
}: ShareCopyButtonProps) {
    return (
        <Button
            className={classNames([
                styles.container,
                {
                    [styles[direction]]: direction !== null,
                    [className]: className !== null,
                    [styles[color]]: color !== null,
                },
            ])}
            {...props}
        >
            <LinkIcon className={styles.icon} />
        </Button>
    );
}

export default ShareCopyButton;
